<script setup lang="ts">
import type { EsProductFragment } from '#graphql-operations'

defineProps<{
  product: EsProductFragment
}>()
</script>

<template>
  <span
    v-for="label in product.marketingLabel"
    :key="label.id"
    class="label"
    :class="`label--${label.label.toLocaleLowerCase()}`"
  >{{ label.label }}</span>
</template>

<style>
@import url("~layers/components/Product/Labels.css");
</style>
